import React, { useState } from 'react'
import { Link } from "react-router-dom";
import { GiHamburgerMenu } from 'react-icons/gi';
import { IoMdClose } from 'react-icons/io';
import emailjs from "@emailjs/browser";


const Hadear = () => {
  const [toggle, setToggle] = useState(false);
  const CloseClick = () => {
    setToggle(false);

  };
  const [ismobile, setIsmobile] = useState(0);

  // const { categorytotal } = useSelector((store) => store.categoryAll);


  const [showAbout, setShowAbout] = useState(true);
  const [showInterior, setShowInterior] = useState(true);
  const [showGallery, setShowGallery] = useState(true);

  const closemenu = () => {
    document.getElementById("mytogglebtn").classList.add("collapsed");
    document.getElementById("menu").classList.remove("in");
  };



  const [name, setName] = useState("");
  const [mail, setmail] = useState("");
  const [massages, setMassages] = useState("");
  const [number, setNumber] = useState("");
  const [state, setState] = useState("");
  const [subject, setSubject] = useState("");
  const [city, setCity] = useState("");

  const nameChange = (e) => {
    const value = e.target.value;
    setName(value);
  };
  const stateChange = (e) => {
    const value = e.target.value;
    setState(value);
  };
  const cityChange = (e) => {
    const value = e.target.value;
    setCity(value);
  };
  const subjectChange = (e) => {
    const value = e.target.value;
    setSubject(value);
  };
  const numberChange = (e) => {
    const value = e.target.value;
    setNumber(value);
  };

  const mailChange = (e) => {
    const value = e.target.value;
    setmail(value);
  };
  const massagesChange = (e) => {
    const value = e.target.value;
    setMassages(value);
  };


  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(

      // "service_oumku8k",
      // "template_esy4tqm",
      // "#myForm",
      // "8i7i_APkS7sZ9CqPl"
    )
      .then(
        function (response) {
          console.log("SUCCESS!", response.status, response.text);
          if (response.text === "OK") {
            setName("");
            setmail("");
            setMassages("");
            setNumber("");
            setState("");
            setSubject("");
            setCity("");

          }
        },
        function (error) {
          console.log("FAILED...", error);
        }
      );
  };
  return (
    <>
      <header className="header-area stricky abcd"  >
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">
              <div className="outer-box clearfix">
                <div className="logo">
                  <Link to="/">
                    <img src="assets/img/svp/logo_1.jpeg" alt="Awesome Logo" style={{ width: "120px", height: "80px", marginTop: "30px" }} />
                    <img src="https://res.cloudinary.com/dnquglkeh/image/upload/v1771511772/%E0%A4%B8%E0%A4%B0%E0%A4%B8%E0%A5%8D%E0%A4%B5%E0%A4%A4%E0%A5%80_wdcxxe.png" alt="Awesome Logo" style={{ width: "140px", height: "80px", marginTop: "30px" }} />
                    {/* style={{ width: "90px", height: "70px" }} */}
                    {/* ./assets/public/website/assets/images/Untitled design (12).png */}
                  </Link>
                </div>
                <nav className="main-menu" style={{ marginTop: "36px" }}>
                  <div className="navbar-header">
                    <button
                      id="mytogglebtn"
                      v
                      className="navbar-toggle collapsed"
                      data-toggle="collapse"
                      data-target="#menu"
                      onClick={closemenu}
                    >
                      <span className="icon-bar" />
                      <span className="icon-bar" />
                      <span className="icon-bar" />

                    </button>
                  </div>
                  <div className="navbar-collapse collapse clearfix" id="menu" >
                    <ul className="navigation clearfix" style={{ fontFamily: "Arial, Helvetica, sans-serif;" }} >
                      <li className="current" >
                        <Link to="/" onClick={closemenu} className=''>
                          Home
                        </Link>
                      </li>

                      <li className="dropdown">
                        <Link to="/about" onClick={closemenu}>About Us</Link>
                        <ul
                          style={
                            showAbout
                              ? { display: "block" }
                              : { display: "none" }
                          }
                        >

                          <li>
                            <Link to="/about" onClick={closemenu}>
                              About Us
                            </Link>
                          </li>

                          <li>
                            <Link to="/mission-vision" onClick={closemenu}>
                              Mission & Vision
                            </Link>
                          </li>
                          <li>
                            <Link to="/director-message" onClick={closemenu}>
                              Director Message
                            </Link>
                          </li>
                          <li>
                            <Link to="/our-team" onClick={closemenu}>
                              Administrative Officer
                            </Link>
                          </li>
                          <li>
                            <Link to="/our-faculty" onClick={closemenu}>
                              Our Faculty
                            </Link>
                          </li>
                        </ul>

                        <div
                          className="dropdown-btn"
                          onClick={() => setShowAbout(!showAbout)}
                        ></div>
                      </li>
                      <li className="">
                        <Link to="/facility" onClick={closemenu}>
                          Facility
                        </Link>
                      </li>
                      <li className="">
                        <Link to="/activities" onClick={closemenu}>
                          Activities
                        </Link>
                      </li>

                      <li className="">
                        <Link to="/gallery" onClick={closemenu}>
                          Gallery
                        </Link>
                      </li>

                      <li className="">
                        <Link to="/faq" onClick={closemenu}>
                          FAQ's
                        </Link>
                      </li>
                      <li className="">
                        <Link to="/contact" onClick={closemenu}>
                          Contact Us
                        </Link>
                      </li>
                       <a href="assets/img/svp/Brochure.pdf" style={{ marginTop: "10px" }} target="_blank" className="theme-btn text-center">
                        <span>Brochure<i className="fa-solid fa-arrow-right-long" /></span>
                      </a>
                    </ul>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  )
}
export default Hadear